import { Site } from '@envato/foundation-types'
import { isDevelopment, isE2ETest } from './envHelper'

// themeforest -> themeforest.net
export const getCurrentSiteDomain = (currentSite: Site) => {
  if (isDevelopment() || isE2ETest()) {
    return `${currentSite}.test`
  } else {
    return `${currentSite}.net`
  }
}

// themeforest.net -> themeforest
export const getCurrentSiteFromDomain = (domain: string) => domain.split('.')[0]
